export default __webpack_public_path__ + "static/media/slack.55ad9eab.png";